module.exports = __webpack_public_path__ + "static/img/recommend_product3_max2.dcadea19.png";